module.exports = __webpack_public_path__ + "static/img/logoVideo.a99685b.png";


//////////////////
// WEBPACK FOOTER
// ./static/video/logoVideo.png
// module id = VwWP
// module chunks = 1